"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    function State() {
        // persons above 24 years old
        this.adults = 2;
        // persons between 16 and 24 years old
        this.juveniles = 0;
        // persons below 16 years old
        this.children = 0;
        // lock the configuration for 2 adults
        this.locked = false;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map